import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Col, Container, Modal, Row, Pagination } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import { Oval } from 'react-loader-spinner'
import { addParticularOwner, allsellItemNFtCount, getAlltransaction, getArtNotificationsRequest, getNotifications, getParticularOwner, getParticularSellItem, getviewCountOwner, likeViewOwner, likeViewSellItem, nftFromCollection, postNotificationRequest, sellItemFromCollectionId, updateSellItem, userAllNftCount } from "store/actions";
import Web3Intraction from "utils/web3Intraction";
import useMetaMask from "hooks/metsmask";
import toastr from "toastr";
import { converCryptoToDollar } from "helpers/constants";
import {
  addTransaction,

} from "store/actions";
import PreviewNFT from "./PreviewNFT";
import moment from "moment";
import Share from "./Share";
import moment1 from "moment-timezone";
import NFTPurchasecenter from "Pages/NFTPurchase/NFTPurchasecenter";
import { Helmet } from "react-helmet";
import Timer from "Component/Timer/Timer";
import Currency from "Component/Currency/Currency";
export default function LiveActionNft() {
  const { id } = useParams()
  const { authToken } = useSelector((state) => state?.Login)
  const current_userId = useSelector((state) => state?.Login?.user?._id)
  // const { userAllNftCounts, nftFromCollectionId } = useSelector((state) => state?.items);
  const { sellItemFromCollectionID, allSellItemNftCounts } = useSelector((state) => state?.SellItems);
  const { sellItem } = useSelector((state) => state?.SellItems);
  const { transactions, } = useSelector((state) => state?.Transactions);
  const [symbol,setSymbol] = useState("$");
  const [convertIntoCurrency, setConvertIntoCurrency]=useState("USD")
  const [nftId, setNftId] = useState('')
  const [buyDialog, setbuyDialog] = useState(false)
  const [usdPrice, setUsdPrice] = useState(0);
  const { user, settings } = useSelector((state) => state?.Login);
  const [maticmainnet, setMaticmainnet] = useState(false);
  const wallAddress = localStorage.getItem("walletAddress");
  const hooks = useMetaMask();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const [bidprice, setBidprice] = useState(0)
  // like and view 
  const user_id = useSelector((s) => s.Login?.user?._id)
  const [recall, setRecall] = useState(false)
  const [isLiked, setIsLiked] = useState(false)
  const [like, setLike] = useState(false)
  var [likeCount, setLikeCount] = useState(1)
  const [likeColor, setLikeColor] = useState(false)
  const [time, setTime] = useState('')
  const [sellItemFromCollectionData, setSellItemFromCollectionData] = useState([])
  const [transactionsData, setTransactionsData] = useState([])
  const [empty, setEmpty] = useState(true)
  const [daysLeft, setDaysLeft] = useState(0)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    function isEmpty(obj) {
      for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
          return false;
        }
      }

      return true;
    }
    setEmpty(isEmpty(sellItem))
  }, [sellItem])
  useEffect(() => {
    setTransactionsData(transactions.filter((item) => item?.sale_type !== "minted"))
  }, [transactions])
  useEffect(() => {
    const x = sellItemFromCollectionID.filter((item) => item.sellType === "auction")
    setSellItemFromCollectionData(x)
  }, [sellItemFromCollectionID])
  // date and time 


  const [timeZone, setTimeZone] = useState('');
  useEffect(() => {
    // Create a DateTimeFormat object
    const dtf = new Intl.DateTimeFormat();

    // Get the resolved options, including the time zone
    const timeZone = dtf.resolvedOptions().timeZone;

    setTimeZone(timeZone);
  }, []);



  const [listingDate, setListingDate] = useState('')
  useEffect(() => {
    const timezone = moment.tz.guess(); // Guess the timezone
    const timezoneOffset = moment.tz(timezone).utcOffset(); // Get timezone offset

    if (sellItem.sellType === "auction") {
      // Convert created_date to local time and format
      let localtime = moment.unix(sellItem?.created_date).local();
      let created_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      setListingDate(created_date);
      
      // Convert auction_time to local time using the timezone offset
      const localMoment = convertUtcToLocal(sellItem?.auction_time, timezoneOffset);
      const date_end = localMoment.format('YYYY-MM-DD HH:mm:ss');
      setTime(date_end);

      // Calculate days left from today
      const today = moment().startOf('day'); // Get today's date at start of day
      const auctionTimeMoment = moment.unix(sellItem?.auction_time).local(); // Convert auction_time to local time
      const daysLeft = auctionTimeMoment.diff(today, 'days'); // Calculate days left
       setDaysLeft(daysLeft);
    }
  }, [sellItem?.created_date, sellItem?.auction_time, sellItem?.sellType]);

  const [recall2, setRecall2] = useState(true)

  const callgetSellItem = () => {
    setTimeout(() => {
      setRecall2(!recall2)
    }, 5000);
  }


  useEffect(() => {
    const callback = (res) => {
      if (res.status === "success") {
      } else {

      }
      setLoading(false)
    }
    callgetSellItem()
    dispatch(getParticularSellItem(id, callback))
  }, [id, data, recall2, dispatch,])


  useEffect(() => {
    if (sellItem?.owner_id?._id) {
      let data = {}
      data.user_id = sellItem?.owner_id?._id
      dispatch(userAllNftCount(data))
      setNftId(sellItem?.nft_id?._id)
    }
  }, [sellItem?.owner_id?._id, dispatch, sellItem?.nft_id?._id])
  useEffect(() => {

    dispatch(sellItemFromCollectionId(id))
  }, [id])
  useEffect(() => {
    if (sellItem?.owner_id) {
      let body = {}
      body.id = sellItem?.owner_id?._id
      dispatch(allsellItemNFtCount(body))
    }
    if (sellItem?.likedUsersId?.includes(current_userId)) {
      setLike(false)
    }
  }, [sellItem])




  useEffect(() => {
    let body = {}
    body.user_id = sellItem?.owner_id?._id
    body.sellitem_id = id
    dispatch(getAlltransaction(body))
  }, [id, sellItem, user_id])

  useEffect(() => {
    if (user_id) {
      var data = {}
      data.user_id = user_id
      data.nft_id = id
      data.isLiked = isLiked
      data.likeStatus = like
      const callback = (res) => {
        if (res.status === "success") {
          setLoading(false)
          setData(res.data)
          if (res?.data?.likedUsersId.includes(user?._id) && (res?.data?.owner_id !== user?._id)) {
            if (res?.data?.owner_id) {
              let data = {}
              data.sender = process.env.REACT_APP_ADMIN_ID
              data.receiver = res?.data?.owner_id
              data.is_read = false
              data.type = "like"
              data.sellItemId = sellItem?._id
              data.content = `${user?.name + " " + user?.lastname} has liked your ${sellItem?.nft_id?.name} Digital Artwork!.`
              dispatch(postNotificationRequest(data, (res) => {
                if (user?._id) {
                  let notificationData = {}
                  notificationData.receiver = user?._id
                  const notificationCallback = (res) => {
                  }
                  dispatch(getArtNotificationsRequest(notificationData, notificationCallback))

                }
              }));
            }
            // }
            // dispatch(getParticularOwner(res?.data?.current_bidder, getParticularOwnerCallback))
          }
        } else {
          setLoading(false)
        }
      }
      dispatch(likeViewSellItem(data, callback))

    }

  }, [user_id, isLiked, recall])
  useEffect(() => {
    if (like) {
      setLike(false)
      setLikeCount(++likeCount)
      setLikeColor(true)
    }
    else {
      setLikeColor(false)
      setLike(true)
      setLikeCount(--likeCount)
    }
  }, [recall])
  useEffect(() => {
    if (user_id) {
      var data = {}
      data.user_id = user_id
      data.nft_id = id
      data.isLiked = isLiked
      data.likeStatus = like
    }
  }, [user_id, isLiked, recall])

  const handleLikeView = (name) => {
    if (user_id) {
      if (name === "like") {
        setIsLiked(true)
        setRecall(!recall)
      }
      else {
        setIsLiked(true)
        setRecall(!recall)
      }
    }

  }








  const [bidProgress, setBidProgress] = useState(false)

  const buyAutionNFT = async () => {
    try {

      if ((bidprice * usdPrice?.data) < Number((sellItem?.current_price * usdPrice?.data + 50).toFixed(4))) {
      // if ((bidprice * usdPrice?.data) < Number((sellItem?.current_price * usdPrice?.data + 0.002).toFixed(4))) {
        return toastr.error("Ensure your bid price is greater than the minimum bid to proceed.");
      } else {
        if (document.getElementById('Agreement').checked) {
          const web3intraction = new Web3Intraction(
            "polygon",
            hooks?.walletType,
            settings
          );
          if (!web3intraction.isNetworkServiceWorking()) {
            return toastr.error("Service Not Available!");
          }
          web3intraction
            .ismatic()
            .then(async (res) => {
              if (!res) {
                setMaticmainnet(true);
                return ''
              }
              setMaticmainnet(false);

              let data1 = {
                buyamount: 1,
                owner: sellItem?.creator_wallet,
                bidamount: (bidprice).toString(),
                tokenId: sellItem?.nft_id?.token_id,
              }
              setBidProgress(true)
              setbuyDialog(false)
              return await web3intraction.placeBid(
                wallAddress,
                data1
              ).then((res) => {
                if (res.status) {
                  const data_transaction = {
                    minted: 0,  // { type: Number, default: 0 }
                    sellitem_id: sellItem?._id,
                    no_of_copies: 1,   //{ type: Number, default: 0 }
                    trans_hash: res?.transHash?.transactionHash,  //{ type: String, required: true }
                    from: sellItem?.creator_wallet, //{ type: String, required: true },
                    to: wallAddress,   //{ type: String, required: true },
                    creator_address: sellItem?.creator_wallet, //{ type: String, required: true },
                    user_id: user?._id, //{ type: mongoose.Schema.Types.ObjectId, ref: "User" },
                    nft_id: sellItem?.nft_id?._id, //{ type: mongoose.Schema.Types.ObjectId, ref: "item", required: true },
                    sale_type: "bid", //{ type: String, required: true },
                    buyer_id: user?._id, //{ type: mongoose.Schema.Types.ObjectId, ref: "User" },
                    buyer_wallet: wallAddress, //{ type: String, required: true },
                    price: sellItem?.current_price,  //{type:Number, required:true},
                    bid_price: bidprice,
                    seller_id: sellItem?.owner_id?._id
                  }

                  dispatch(addTransaction(data_transaction, (recall) => {

                  }))
                  const data_owner = {
                    nft_id: sellItem?.nft_id?._id,
                    owner_id: user?._id,
                    total_copies: 1,
                    price: bidprice,
                    available_copies: 1,
                    creator: sellItem?.nft_id?.author_id,
                    buy_from: sellItem?.creator_wallet,
                    status: true,
                    owner_wallet: wallAddress,
                    loyality: sellItem?.loaylty,
                    onSale: false,
                    ownership_status: "Pending",
                    sale_event: "Auction",
                    owner_type: true,
                    sellItem_id: sellItem?._id
                  }
                  dispatch(addParticularOwner(data_owner, (responseowner) => {
                    if (responseowner?.status === "success") {
                      const data_update = {
                        _id: sellItem?._id,
                        current_bidder: responseowner?.data?._id,
                        current_price: bidprice,
                        no_of_bids: Number(sellItem?.no_of_bids) + 1,
                        collection_update: false
                      }



                      dispatch(updateSellItem(data_update, (recall1) => {
                        if (recall1.status === "success") {
                          let data = {}
                          data.sender = process.env.REACT_APP_ADMIN_ID
                          data.receiver = user?._id
                          data.is_read = false
                          data.type = "bid"
                          data.sellItemId = sellItem?._id
                          data.content = `Bid Successful! You've placed a bid on ${sellItem?.nft_id?.name}. We'll keep you updated on auction.`
                          dispatch(postNotificationRequest(data));
                          let data2 = {}
                          data2.sender = process.env.REACT_APP_ADMIN_ID
                          data2.receiver = responseowner?.data?._id
                          data2.is_read = false
                          data2.type = "bid"
                          data.sellItemId = sellItem?._id
                          data2.content = `Heads Up!  You've been outbid on ${sellItem?.nft_id?.name}. Don't miss out; consider placing a higher bid!`
                          dispatch(postNotificationRequest(data2));
                          toastr.success("Your bid has been submitted successfully");
                          setBidProgress(false)
                          // notification to user whoo loose bid
                          if (sellItem?.current_bidder && sellItem?.current_bidder !== "") {
                            const getParticularOwnerCallback = (res) => {
                              if (sellItem?.current_bidder && sellItem?.current_bidder !== "") {
                                let data = {}
                                data.sender = process.env.REACT_APP_ADMIN_ID
                                data.receiver = res?.data[0]?.owner_id
                                data.is_read = false
                                data.type = "bid"
                                data.sellItemId = sellItem?._id
                                data.content = `Outbid Notification: Your bid on ${sellItem?.nft_id?.name} has been surpassed.`
                                dispatch(postNotificationRequest(data, () => {
                                  if (user?._id) {
                                    let notificationData = {}
                                    notificationData.receiver = user?._id
                                    dispatch(getArtNotificationsRequest(notificationData))

                                  }
                                }));
                              }
                            }

                            let particualrOwnerdata = {}

                            particualrOwnerdata.owner_id = user?._id
                            particualrOwnerdata.sellItem_id = sellItem?._id

                            dispatch(getParticularOwner(particualrOwnerdata, getParticularOwnerCallback))
                          }

                        }
                      }))

                    }

                  }))
                } else {
                  setBidProgress(false)

                  return toastr.error("Transaction has been rejected");
                }
              }).catch((err) => {
                setBidProgress(false)

                return toastr.error(err.message);
              })
            })
        } else {
          toastr.error("Please check the Digital Artwork Purchase & IP License Agreement")
        }
      }
    } catch (err) {
      // setnftCreate(false);
      setBidProgress(false)
      return toastr.error("Something going wrong.");

    }
  }
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const calPrice = async () => {
        let amount = Number(sellItem?.current_price);
        let symbol = "MATIC";
        let data = await converCryptoToDollar(amount, symbol, convertIntoCurrency);
        setUsdPrice((pre) => ({
          ...pre,
          data,
        }));
      };
      calPrice({ price: 1 });
    }, 300);
    return () => clearTimeout(delayDebounceFn);
  }, [sellItem, convertIntoCurrency]);

  const getamount = (e) => {
    setBidprice(e.target.value)
  }
  // pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    let x = 0;
    if (transactionsData?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(transactionsData.length / 10);
    }
    const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
    setDataLength(newLengthArray);
  }, [transactions]);
  const [viewnftDialog, setviewnftDialog] = useState(false)
  const [nftlink, setNftLink] = useState()
  const viewnftBtn = (data) => {
    setviewnftDialog(!viewnftDialog)
    setNftLink(data)
  }


  useEffect(() => {
    if (transactionsData?.length < 9) {
      setDataLength([1]);
    } else {
      const x = Math.ceil(transactionsData.length / 10);
      const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
      setDataLength(newLengthArray);
    }

  }, [transactionsData]);

  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (transactionsData[i]) {
        arr.push(transactionsData[i]);
      }
    }

    setDataAfterPagination(arr);
  }, [values, transactionsData, dataLength]);
  const handlePagination = (val) => {
    let valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = Math.max(0, values - 10);
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < transactionsData.length) {
      valu = Math.ceil(transactionsData.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };

  const buynowBtn = () => {
    setbuyDialog(!buyDialog)
  }
  const [serviceAgree, setserviceAgree] = useState(false);
  function serviceag() {
    setserviceAgree(true)
  }
  function closeTerms() {

    setserviceAgree(false)

  }

  const [readMore, setReadmore] = useState(false)
  const readmore = () => {
    setReadmore(!readMore)
  }


  const setCurrnencyTobeConverted=(currency, symbol)=>{
    setConvertIntoCurrency(currency)
    setSymbol(symbol)
  }



  useEffect(()=>{console.log("usdPrice", usdPrice)}, [usdPrice])
  return (
    <>
      {(loading) &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <div className="application">
        <Helmet>
          <title>{"Terpnash - Making Physical Art Fair and Digital"}</title>
          <meta property="og:title" content={sellItem?.nft_id?.name}/>
          <meta property="og:image" content={sellItem?.nft_id?.image_id?.image?.water_mark_image_link} />
          <meta property="og:description" content= {sellItem?.nft_id?.description}/>
          <meta property="og:url" content={process.env.REACT_APP_DOMAIN_PREFIX+`/liveAuctionNft/${sellItem?._id}`} />
        </Helmet>
      </div>

      <Modal className="EmailVerifyBoxModel buynowDialog text-center" show={bidProgress} centered animation={false}>
        <div className="processingDialog">
          <h1><i className="fa-duotone fa-loader"></i></h1>
          <h1>Processing</h1>
          <p>Metamask processing....</p>
        </div>
      </Modal>
      <Modal className="EmailVerifyBoxModel previewnftDialog text-center" show={viewnftDialog} centered animation={false}>
        <PreviewNFT fucn={viewnftBtn} nftData={nftlink} />
      </Modal>

      <Modal className="EmailVerifyBoxModel buynowDialog text-center" show={buyDialog} centered animation={false}>
        <div className="dialogHeader px-3" >
          <h3>Place Bid</h3>
          <button onClick={buynowBtn}><i className="fa-regular fa-xmark"></i></button>
         
        </div>
        <div className="buyNowBox">
        {/* <p className="notetext"> <b >Note:</b> To protect the artist and their work, we have inserted a watermark and reduced the file size to prevent misuse of the artists image. The Digital Artwork you purchase is the original file provided directly from the artist and is the highest quality they can provide.</p> */}
          <div className="nftnameBox">
            <div className="nftname">
              <div className="nftImg">
                <img src={sellItem?.nft_id?.image_id?.image?.link} className="img-fluid" alt="" />
              </div>

              <>{(sellItem?.nft_id?.name)?.length > 15 ? <h3>{(sellItem?.nft_id?.name)?.substring(0, 10) + "....."}</h3> : <h3>{sellItem?.nft_id?.name}</h3>}</>
            </div>
            <div className="nftprice">
              <h3 className="d-flex align-items-center gap-2"> {Number(sellItem?.current_price).toFixed(6)}  <img src="/images/svg/maticIcon.svg" className="img-fluid" width={20} alt="" /> ( ${(sellItem?.current_price * usdPrice?.data).toFixed(6)}) </h3>

            </div>
          </div>
        </div>
        <div className="buyNowBox">
          <div className="nftnameBox">
            <div className="nftname">
              <div className="nftImg">
                <img src="/images/svg/maticIcon.svg" className="img-fluid" alt="" />
              </div>
              <div>
                {(wallAddress && wallAddress != "undefined") ? <><h3>{wallAddress?.substring(0, 7) + "......" + wallAddress?.substring(32)}</h3></> : <h3>*******</h3>}
                <p>POL</p>
              </div>
            </div>
            <div className="nftprice">
              {(wallAddress && wallAddress != "undefined") ? <button className="connected">Connected</button> : <button className="connected">Not Connected</button>}
            </div>
          </div>
        </div>
        <div className="buyNowBox">
          <div className="nftnameBox border-0  px-0 rounded-0">
            <h3>Sale ends at</h3>
            <h3>{time}</h3>
          </div>
          <div className="nftnameBox border-0 px-0 rounded-0 pb-1">
            <h3>Place Your Bid</h3>

          </div>
          <div className="nftnameBox border-0 border-bottom border-dark px-0 rounded-0 pt-0">
            <div className="form-group w-100">
              <Input type="number" className="form-control" placeholder="Enter your bid amount..." disabled={!wallAddress} onChange={(e) => getamount(e)} />
              <div className="d-flex align-items-center justify-content-between bidinfo">
                <p className="fw-samibold mb-0">~ $({(usdPrice?.data * bidprice).toFixed(4)})</p>
                <p className="mb-0 end-0">Min. Bid - ({(sellItem?.current_price + (1 / usdPrice?.data) * 50).toFixed(5)}) POL </p>
              </div>
            </div>
          </div>
        </div>
        <div className="buyNowBox">
          <div className="CustomeCheckBox">
            <Input type="checkbox" id="Agreement" />
            <label className="cursor-pointer" htmlFor="Agreement"></label>
            <div><span className=" text-black">I agree to  <span
              onClick={serviceag}
              className="link_text mb-0 cursor-pointer"
            >
              {" "}
              Digital Artwork Purchase & IP License Agreement
            </span></span></div>
          </div>
        </div>
        <div className="buyNowBox">
          {(wallAddress && wallAddress !== "undefined") ? <><button className="btn btn-secondary text-white py-3 w-100" onClick={buyAutionNFT}>Place Bid</button></> : <button className="btn btn-danger text-white py-3 w-100" onClick={() => navigate("/metamask-sign")} >Connect Metamask</button>}
        </div>
        <p className="text-danger d-flex align-items-center justify-content-center gap-2 " >{maticmainnet ? <> Please switch to Matic (Polygon) network <Link className="text-decoration-none text-danger" to={'https://www.coindesk.com/learn/how-to-connect-metamask-to-the-polygon-network/'} target={'_blank'}><sup><i class="fa-solid fa-circle-info"></i></sup></Link> </> : ""}</p>
      </Modal>
      <Modal
        className="termandCoDialog"
        show={serviceAgree}
        centered
        animation={false}
      >
        <div className="text-end">
          <button onClick={closeTerms} className="btn cancelbtn end-0 top-0">
            <img src="/images/svg/closeIconDialog.svg" alt="" />
          </button>
        </div>
        <div className="contentBoxdialog">
          <NFTPurchasecenter />
          <button
            className="btn btn-primary px-5 btn-sm py-2"
            onClick={closeTerms}
          >
            Back
          </button>
        </div>
      </Modal>
      <Header />
      <div className="container-fluid profileBox nftview">
        <Row>
          <Col lg={12}>
            <h1>DIGITAL ARTWORK LIVE AUCTION</h1>
          </Col>
        </Row>
      </div>
      {(!empty && sellItem?.sale_status !== "expired") ? (
        <div className="container-fluid nftViewBoxMaine text-start py-5">
          <Container>
            <Col lg={12} className="mb-4">
              <div className="ownednftBox p-3">
                <Row>
                  <Col className="mb-4" lg={7}>
                    <div className="d-flex align-items-center gap-3 tagname">
                      <p className="hashTag">
                        <span>#{sellItem?.nft_id?.category_id?.name}</span>
                        <span>#{sellItem?.nft_id?.subcategory?.name}</span>
                      </p>
                    </div>
                    <h1>{sellItem?.nft_id?.name}</h1>
                    <h1 className="d-flex align-items-center artRate matic gap-3 mb-2 mt-3">
                      {" "}
                      <img
                        src="/images/svg/maticIcon.svg"
                        width="30"
                        height="30"
                        alt=""
                      />{" "}
                      {Number(sellItem?.current_price).toFixed(6)} POL ( {symbol+" "+Number( usdPrice?.data).toFixed(6)} <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />)
                    </h1>
                    <p className="fw-semibold mb-0">Sale ends at {time}</p>
                    <p className="fw-semibold mb-0 timelest ">Time Left : {daysLeft} {daysLeft> 1?  "Days" : "Day"}  <Timer date={time}/></p>
                    <p className="fw-semibold">Royalty percentage : {sellItem?.loaylty} %</p>
                    <p className="fw-semibold">Type of artwork : {sellItem?.nft_id?.category_id?.name}</p>
                    <div className="bidBox">
                      <div className="opningAmount cursor-auto">
                        Opening Amount-  {sellItem?.nft_id?.price} POL
                      </div>
                      <div className="totalbids cursor-auto">Total bids till now - {sellItem?.no_of_bids}</div>
                      {authToken ? <><button className="btn opningAmount px-5 " onClick={buynowBtn}>Place Bid</button></> : <Link className="btn text-decoration-none opningAmount px-5 " to={"/login"}>Place Bid</Link>}
                      <p className="notetext"> <b >Note:</b> <br /> To protect the artist and their work, we have inserted a watermark and reduced the file size to prevent misuse of the artists image. The Digital Artwork you purchase is the original file provided directly from the artist and is the highest quality they can provide.</p>
                
                    </div>

                    <ul >
                      <li>

                        <button > <i className="fa-solid eye fa-eye"></i> {sellItem?.view_count} Views</button>
                      </li>
                      <li>
                        {authToken ? <>  <button onClick={() => handleLikeView("like")}> {like === false ? <i className="fa-solid heart fa-heart"></i> : <i className="fa-regular fa-heart"></i>} {sellItem?.like_count} Like</button></> : <button > {like === false ? <i className="fa-solid heart fa-heart"></i> : <i className="fa-regular fa-heart"></i>} {sellItem?.like_count} Like</button>}
                      </li>
                      <li className="sharebtnLi">
                        <button className="shareBtn">
                          <span className="nftText">Share Digital Artwork </span>  <i className="fa-sharp fa-regular fa-share-nodes"></i>
                        </button>
                        <div className="shareBoxNew">
                          <Share sharedata={nftlink} />
                        </div>
                      </li>
                    </ul>

                  </Col>
                  <Col className="text-end m-auto mb-3" lg={5}>
                    <div className='nftviewBoxNew'>
                      <img src={sellItem?.nft_id?.image_id?.image?.water_mark_image_link ? sellItem?.nft_id?.image_id?.image?.water_mark_image_link : sellItem?.nft_id?.image_id?.image?.link} className='blurimg' alt="" />
                      <div className="ownednftImgBox cursor-pointer " onClick={() => viewnftBtn(sellItem)}>
                        <img
                          src={sellItem?.nft_id?.image_id?.image?.water_mark_image_link ? sellItem?.nft_id?.image_id?.image?.water_mark_image_link : sellItem?.nft_id?.image_id?.image?.link}
                          className="img-fluid"
                          alt=""
                        />
                        <button className="sallerBox position-absolute bottom-0 mb-2 me-2 end-0">SELLER - {sellItem?.owner_id?.role}</button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Row>
              <Col className="mb-4" lg={4}>
                <div className="bidBox bidBoxNew discriptionBox mb-4">
                  <h2>Description</h2>
                  <p className="scrollheight">
                    {sellItem?.nft_id?.description}
                  </p>
                  {sellItem?.nft_id?.relatedImages?.link ? (<>
                    <h2>Additional Files</h2>
                    <p className="scrollheight">{sellItem?.nft_id?.supportDocDescription}</p>
                    <div className="fileBox">
                      <div className="filename">
                        <p > {sellItem?.nft_id?.relatedImages?.link?.slice(sellItem?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === ".pdf" ? <i class="fa-regular fa-file-pdf"></i> : sellItem?.nft_id?.relatedImages?.link.slice(sellItem?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === ".png" || ".jpg" || ".jpeg" ? <i class="fa-regular fa-image"></i> : sellItem?.nft_id?.relatedImages?.link.slice(sellItem?.nft_id?.relatedImages?.link.lastIndexOf(".")).toLowerCase() === (".mp4") ? <i class="fa-regular fa-video"></i> : <i class="fa-regular fa-headphones"></i>}File</p>

                      </div>
                    </div> </>) : ("")
                  }
                </div>
                <div className="bidBox bidBoxNew mt-4 aboutAuther">
                  <div className="d-flex align-items-center justify-content-between aboutseelerHead">
                    <h2>About Seller</h2>
                    <div className="sharebtnLi">
                      <button>
                        <i className="fa-sharp fa-regular fa-share-nodes"></i>
                      </button>
                      <div className="shareBoxNew">
                        <Share />
                      </div>
                    </div>
                  </div>
                  <div className="autherProfile">
                    <div className="authImg">
                      <img src={sellItem?.owner_id?.profileImage?.link} alt="" />
                    </div>
                    <div className="authDetails">
                      <h3>{sellItem?.owner_id?.name}{" "} {sellItem?.owner_id?.lastname} </h3>
                      {/* <p>0xa92820e5b94e8d2c</p> */}
                    </div>
                  </div>
                  <p className={"hidecontent " + (readMore === true ? 'active' : '')} id="descriptionText">
                    {sellItem?.owner_id?.description}
                  </p>{sellItem?.owner_id?.description?.length > 300 &&
                    <p className="ms-auto text-secondary fw-semibold cursor-pointer " onClick={readmore}>{readMore === true ? 'Read Less' : 'Read More'}</p>
                  }
                  <div className="d-flex align-items-center justify-content-end w-100 gap-3">
                    <button className="btn btn-outline-dark px-4">
                      Total Views - {allSellItemNftCounts}
                    </button>
                    <Link to={`/view-profile/${sellItem?.owner_id?._id}`} className="btn btn-outline-secondary px-4">
                      View Profile
                    </Link>
                  </div>
                </div>
              </Col>
              <Col className="mb-3" lg={8}>
                <div className="listing mb-4">
                  <h2>
                    <i className="fa-light fa-tag me-2"></i> Listings
                  </h2>
                  <div className="table-responsive">
                    <table className="nftlistTable">
                      <thead>
                        <tr>
                          <td>Price</td>
                          <td className="text-center">USD Price</td>
                          <td className="text-center">Quantity</td>
                          <td className="text-center">Date</td>
                          <td className="text-center">From</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{sellItem?.nft_id?.price} POL </td>
                          <td className="text-center">${(sellItem?.nft_id?.price * usdPrice?.data).toFixed(4)}</td>
                          <td className="text-center">1</td>
                          <td className="text-center">{listingDate} </td>
                          <td className="text-center">{sellItem?.buyer_wallet?.substring(0, 5)}.....{sellItem?.buyer_wallet?.substring(sellItem?.buyer_wallet?.length - 4, sellItem?.buyer_wallet?.length)}</td>
                          <td className="text-center">
                        
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="listing mb-4">
                  <h2>
                    <i className="fa-sharp fa-light fa-list-ul me-2"></i> Offers
                  </h2>
                  <div className="table-responsive">
                    <table className="nftlistTable">
                      <thead>
                        <tr>
                          <td>Price</td>
                          <td className="text-center">USD Price</td>
                          <td className="text-center">Quantity</td>
                          <td className="text-center">Bid price</td>
                          <td className="text-center">From</td>
                        </tr>
                      </thead>
                      <tbody>
                        {dataAfterPagination && dataAfterPagination.map((item, index) =>
                          <tr key={index}  >
                            <td>{item?.price} POL </td>
                            <td className="text-center">$ {(item?.price * usdPrice?.data).toFixed(4)}</td>
                            <td className="text-center">1</td>
                            <td className="text-center">{item?.bid_price} POL</td>
                            <td className="text-center">{item?.creator_address.substring(0, 5)}.....{item?.creator_address.substring(item?.creator_address.length - 4, item?.creator_address.length)}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {dataAfterPagination.length > 0 && <Col lg={12} className="text-end">
                  <Pagination
                    className="paginationNew"
                    aria-label="Page  navigation example"
                  >
                    {values > 10 && (
                      <div>
                        <PaginationItem>
                          <PaginationLink
                            first
                            href="#"
                            onClick={() => handlePagination("<<")}
                          />
                        </PaginationItem>
                        <PaginationItem>
                          <PaginationLink
                            href="#"
                            previous
                            onClick={() => handlePagination("<")}
                          />
                        </PaginationItem>
                      </div>
                    )}
                    {dataLength &&
                      dataLength.map((item) => (
                        <PaginationItem
                          className={parseInt(item) === values / 10 ? "active" : ""}
                        >
                          <PaginationLink
                            href="#"
                            onClick={() => handlePagination(item)}
                          >
                            {item}
                          </PaginationLink>
                        </PaginationItem>
                      ))}
                    {values < transactions.length && (
                      <div>
                        <PaginationItem>
                          <PaginationLink
                            href="#"
                            next
                            onClick={() => handlePagination(">")}
                          />
                        </PaginationItem>
                        <PaginationItem>
                          <PaginationLink
                            href="#"
                            last
                            onClick={() => handlePagination(">>")}
                          />
                        </PaginationItem>
                      </div>
                    )}
                  </Pagination>
                </Col>}

              </Col>




            </Row>
            <Row className="mt-4">
              {sellItemFromCollectionData.length > 0 &&
                <Col lg={12}>
                  <h4 className="moreCollection mb-4">More from this collection</h4>
                </Col>
              }
              {sellItemFromCollectionData && sellItemFromCollectionData.map((item, index) => {
                return (
                  <Col lg={3}>
                    <Link className="text-decoration-none" to={`/liveAuctionNft/${item._id}`}>
                      <div className="TrandingArtistMaineBox">
                        <div className="imgBox">
                          <div className="imginn">
                            <img
                              className="img-fluid"
                              src={(user?._id && user?._id === item?.owner_id) ? item?.nft_id?.image_id?.image?.link : item?.nft_id?.image_id?.image?.water_mark_image_link ? item?.nft_id?.image_id?.image?.water_mark_image_link : item?.nft_id?.image_id?.image?.link}
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="contBox mt-2">
                          <div className="arthead mb-2">
                            <h2 className="productName">{item?.nft_id?.name}</h2>
                            <h2 className="productName fw-normal">{item?.nft_id?.price} POL</h2>
                          </div>
                          <p>
                            {item?.nft_id?.description}
                          </p>
                          <div className="d-flex align-items-center justify-content-between mt-3">
                            <p><i className="fa-regular fa-eye"></i> <span className="fw-semibold">Views</span> {item?.nft_id?.view_count}</p>
                            <p><i className="fa-regular fa-heart"></i> <span className="fw-semibold">Likes</span> {item?.nft_id?.like_count}</p>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </Col>)
              })}
            </Row>
          </Container>
        </div>
      ) : (<><> <div className="text-center d-grid justify-content-center dataNotFound py-5">
        <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
        {empty ? (<h3>No Digital Artwork Found</h3>) : (<h3>Auction Expired</h3>)}
      </div></></>)
      }

      <Footer />
    </>
  );
}
const convertUtcToLocal = (utcTimestamp, timezoneOffset) => {
  const utcMoment = moment1.unix(utcTimestamp);
  const localMoment = utcMoment.utcOffset(timezoneOffset);
  return localMoment;
}















































